import React from 'react';
import { motion } from 'framer-motion';
import './LandingCTA.css';
import LandingButton from '../LandingButton/LandingButton';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const handleWhatsAppContact = () => {
  const phoneNumber = '573163756770';
  const message = encodeURIComponent('¡Hola! Me gustaría solicitar mi catálogo de OviCatalogos');
  window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
};

function LandingCTA() {
  return (
    <section className="ovicatalogos-cta">
      <div className="ovicatalogos-cta-gradient-1" />
      <div className="ovicatalogos-cta-gradient-2" />
      
      <div className="ovicatalogos-cta-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="ovicatalogos-cta-box"
        >
          <div className="ovicatalogos-cta-box-gradient-1" />
          <div className="ovicatalogos-cta-box-gradient-2" />
          
          <div className="ovicatalogos-cta-content">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="ovicatalogos-cta-badge"
            >
              <div className="ovicatalogos-cta-badge-pulse" />
              <span className="ovicatalogos-cta-badge-text">Empieza hoy mismo</span>
            </motion.div>
            
            <h2 className="ovicatalogos-cta-title">
              ¿Listo para tener un catálogo que trabaje por ti?
            </h2>
            
            <p className="ovicatalogos-cta-description">
              Únete a los emprendedores que ya están vendiendo más con catálogos inteligentes. 
              Es momento de dejar atrás los catálogos desactualizados y los pedidos perdidos.
            </p>
            
            <div className="ovicatalogos-cta-buttons">
              <LandingButton
                variant="white"
                size="lg"
                icon={faWhatsapp}
                onClick={handleWhatsAppContact}
                className="ovicatalogos-cta-btn-primary"
              >
                Solicitar mi catálogo ahora
              </LandingButton>
              
              <LandingButton
                variant="ghost"
                size="lg"
                className="ovicatalogos-cta-btn-secondary"
              >
                Ver demo
                <span className="ovicatalogos-cta-arrow">→</span>
              </LandingButton>
            </div>
            
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
              className="ovicatalogos-cta-footer"
            >
              <p className="ovicatalogos-cta-features">
                ✓ Configuración en minutos • ✓ Sin pagos iniciales • ✓ Soporte incluido
              </p>
              <p className="ovicatalogos-cta-note">
                Respuesta inmediata por WhatsApp
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default LandingCTA;
